import styled from "styled-components";

export const DeviceOverviewWrapper = styled.div`
    width: 100%;
    margin-top: 10px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 100px;
    grid-gap: 10px;
    align-items: center;
    justify-items: stretch;
`

export const DeviceTotalWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: 100%;
    background-color: #ecdaa8a6;
`

export const DeviceOnlineWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: 100%;
    background-color: #88e2f860;
`

export const Icon = styled.div`
    display: flex;
    align-items: left;
    justify-content: center;
    margin-left: 10px;

   .anticon {
       font-size: 56px;
   }    
`

export const TextWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex: 1;
    flex-direction: column;
`

export const Text = styled.div`
   font-size: 16px;
   font-weight: bold;
   margin: 0 8px;
   padding: 5px 0;
   text-align: center;
   color: #5f5e5e;
   white-space: nowrap;
   overflow: hidden;
`;

